// src/pages/health/WorkoutPrescriptionVideo.jsx
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

// 임시 썸네일 (프로젝트 내 이미지 재사용)
import legextension2 from "../../../../assets/images/legextension2.png";
import AuthCard from "../../../../components/auth/AuthCard";
import BottomNav from "../../../../components/common/BottomNav";
import { useLoadingGate } from "../../../../hooks/useLoadingGate";

const CATEGORY_OPTIONS = [
    { key: "release", label: "억제 / 이완" },
    { key: "shoulder", label: "어깨 / 승모" },
    { key: "neck", label: "목" },
    { key: "hip", label: "고관절" },
];

const ALL_VIDEOS = [
    { id: "v1", category: "release", title: "사각근 자가근막이완 - 공", thumb: legextension2 },
    { id: "v2", category: "release", title: "승모근 자가근막이완 - 써라케인", thumb: legextension2 },
    { id: "v3", category: "release", title: "광배근 자가근막이완 - 폼롤러", thumb: legextension2 },
    { id: "v4", category: "release", title: "흉요근막 이완 - 폼롤러", thumb: legextension2 },

    { id: "v5", category: "shoulder", title: "어깨 전면 스트레칭", thumb: legextension2 },
    { id: "v6", category: "shoulder", title: "견갑 고정 패턴", thumb: legextension2 },

    { id: "v7", category: "neck", title: "사이드 넥 스트레칭", thumb: legextension2 },
    { id: "v8", category: "neck", title: "승모 하부 활성화", thumb: legextension2 },

    { id: "v9", category: "hip", title: "둔근 활성화 - 클램셸", thumb: legextension2 },
    { id: "v10", category: "hip", title: "고관절 가동성 루틴", thumb: legextension2 },
];

export default function WorkoutPrescriptionVideo() {
    const ready = useLoadingGate();
    const navigate = useNavigate();

    // 드롭다운
    const [open, setOpen] = useState(false);
    const [cat, setCat] = useState(CATEGORY_OPTIONS[0].key);
    const selectRef = useRef(null);

    useEffect(() => {
        const onDoc = (e) => {
            if (!selectRef.current) return;
            if (!selectRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, []);

    const catLabel = useMemo(
        () => CATEGORY_OPTIONS.find((c) => c.key === cat)?.label ?? "",
        [cat]
    );

    const list = useMemo(
        () => ALL_VIDEOS.filter((v) => v.category === cat),
        [cat]
    );

    return (
        <main className="h-[var(--app-height)] flex flex-col font-suit overflow-y-auto scrollbar-hide px-7 md:px-8 bg-white">
            {!ready ? (
                <div className="flex-1" />
            ) : (
                <AuthCard
                    className="flex-1 w-full mx-auto"
                    title={"운동 처방 영상"}
                    onClose={() => navigate(-1)}
                >
                    <div className="flex flex-col flex-1 pt-3 md:pt-4 pb-24 md:pb-28">
                        <div className="relative" ref={selectRef}>
                            <button
                                type="button"
                                onClick={() => setOpen((v) => !v)}
                                className="w-full h-12 md:h-13 px-4 rounded-xl bg-gray-100 border border-gray-200 text-gray-900 flex items-center justify-between shadow-sm"
                                aria-haspopup="listbox"
                                aria-expanded={open}
                            >
                                <span className="font-medium">{catLabel}</span>
                                <ChevronDownIcon
                                    className={`w-5 h-5 text-gray-700 transition-transform ${open ? "rotate-180" : ""
                                        }`}
                                />
                            </button>

                            {open && (
                                <ul
                                    role="listbox"
                                    className="absolute z-10 mt-1 w-full max-h-64 overflow-y-auto rounded-xl border border-gray-200 bg-white shadow-lg"
                                >
                                    {CATEGORY_OPTIONS.map((o) => (
                                        <li key={o.key} role="option" aria-selected={cat === o.key}>
                                            <button
                                                className={`w-full text-left h-11 px-4 ${cat === o.key
                                                    ? "bg-[#E8F1FF] text-[#1F4FD3] font-semibold"
                                                    : "hover:bg-gray-100"
                                                    }`}
                                                onClick={() => {
                                                    setCat(o.key);
                                                    setOpen(false);
                                                }}
                                            >
                                                {o.label}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="my-3 md:my-4">
                            <div className="h-px bg-gray-100" />
                        </div>

                        {/* 비디오 그리드 */}
                        <ul className="grid grid-cols-2 gap-3 md:gap-4">
                            {list.map((v) => (
                                <li key={v.id}>
                                    <button
                                        type="button"
                                        className="w-full rounded-2xl  bg-white transition"
                                        onClick={() => {
                                            // navigate(`/workout/video/${v.id}`)
                                            console.log("clicked:", v.id);
                                        }}
                                    >
                                        <div className="aspect-video w-full overflow-hidden border border-gray-200">

                                        </div>
                                        <div className="px-3 py-2">
                                            <p className="text-sm md:text-base font-medium leading-tight line-clamp-2 text-center">
                                                {v.title}
                                            </p>
                                        </div>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </AuthCard>
            )}

            <BottomNav className="h-16 md:h-[72px]" />
        </main>
    );
}
